<template>
    <v-card>
        <v-card-text>
            <v-layout>
                <v-flex ref="parent">
                    <pad-draw-field v-show="modeImage" ref="field" :width="parentWidth" :x="x" :item="item" />
                    <v-textarea v-if="!modeImage"
                        outline
                        single-line
                        hide-details
                        label="Notes"
                        v-model="item.notes"
                        :rows="7" />
                </v-flex>
                <v-flex shrink align-self-end>
                    <v-btn block flat icon large color="warning" @click="clearNotes" :disabled="loading">
                        <v-icon large>undo</v-icon>
                    </v-btn>
                    <v-divider />
                    <v-btn block flat icon large color="secondary" @click="toggleMode" :disabled="loading">
                        <v-icon large>repeat</v-icon>
                    </v-btn>
                    <v-divider />
                    <v-btn block flat icon large color="primary" @click="saveNotes" :disabled="loading">
                        <v-icon large>save</v-icon>
                    </v-btn>
                </v-flex>
            </v-layout>
        </v-card-text>
    </v-card>
</template>

<script>
import PadDrawField from '@/components/PadDrawField'

export default {
    name: 'pad-lot-notes',
    components: { PadDrawField },
    props: {
        item: { type: Object }
    },
    data: () => ({
        loading: false,
        parentWidth: 0,
        modeImage: true,
        x: 0
    }),
    computed: {
        visa() {
            return this.$store.getters['visa/visa']
        }
    },
    mounted() {
        this.parentWidth = this.$refs.parent.offsetWidth
        this.x = this.$refs.parent.offsetLeft
        this.load()
    },
    methods: {
        load() {
            this.loading = true
            return this.$api.get(`/apad/lots/${this.item.id}/notes`)
                .then(res => {
                    if (!res.data) {
                        return
                    }
                    const img = new Image()
                    img.crossOrigin = 'use-credentials'
                    img.src = `${this.$api.defaults.baseURL}/apad/lots/${this.item.id}/notes`
                    img.onload = () => {
                        this.$refs.field.setImage(img)
                    }
                })
                .finally(() => this.loading = false)
        },
        toggleMode() {
            this.modeImage = !this.modeImage
        },
        saveNotes() {
            const tasks = [
                this.$api.put(`/apad/lots/${this.item.id}/notes`, {
                    notes: this.item.notes,
                    visa: this.visa
                })
            ]
            if (this.modeImage) {
                tasks.push(this.saveNotesImage())
            }
            this.loading = true
            return Promise.all(tasks)
                .then(() => this.$store.commit('msg/show', { message: 'Notes enregistrées' }))
                .finally(() => this.loading = false)
        },
        saveNotesImage() {
            return this.$refs.field.getBlob()
                .then(blob => {
                    const data = new FormData()
                    data.append('visa', this.visa)
                    data.append('notes', blob)
                    return this.$api.post(`/apad/lots/${this.item.id}/notes`, data, {
                        'Content-Type': 'multipart/form-data'
                    })
                })
                .then(data => {
                    this.item.notes_img = true
                    return data
                })
        },
        clearNotes() {
            this.$refs.field.clear()
        }
    }
}
</script>
